// components
import ContentLayout from "@/layouts/ContentLayout";
import TitleBanner from "@/components/banners/TitleBanner";
import TextBlock from "@/components/blocks/TextBlock";
import StatisticCard from "@/components/cards/StatisticCard";

// assets
import banner from "@/assets/images/used-cooking-oil-recycling/banner.png";
import image1 from "@/assets/images/used-cooking-oil-recycling/image1.png";
import image2 from "@/assets/images/used-cooking-oil-recycling/image2.png";
import co2 from "@/assets/images/used-cooking-oil-recycling/co2.png";
import oil from "@/assets/images/used-cooking-oil-recycling/oil.png";
import money from "@/assets/images/used-cooking-oil-recycling/money.png";

// i18n
import { useTranslation } from "react-i18next";

const UsedCookingOilRecycling = () => {
  const { t } = useTranslation();

  const statistics = [
    {
      icon: co2,
      value: "89%",
      unitKey: "less_ghg",
      descriptionKey: "less_ghg_description",
    },
    {
      icon: oil,
      value: "7.49",
      unitKey: "million_tonnes",
      descriptionKey: "million_tonnes_description",
    },
    {
      icon: money,
      value: "46%",
      unitKey: "more_economic",
      descriptionKey: "more_economic_description",
    },
  ];

  return (
    <div className="w-full">
      <TitleBanner bannerImg={banner} title={t("used_cooking_oil_recycling.used_cooking_oil_recycling")} />
      <ContentLayout>
        <article className="flex w-full flex-col gap-6">
          <div className="flex w-full flex-col gap-12 lg:flex-row">
            <TextBlock
              title="turning_waste_into_energy"
              descriptions={["turning_waste_into_energy_description_1", "turning_waste_into_energy_description_2"]}
              translationKey="used_cooking_oil_recycling"
            />
            <figure className="flex h-[400px] w-full items-center justify-center overflow-hidden">
              <img src={image1} alt="about-us-image1" className="w-full object-cover" />
            </figure>
          </div>

          <TextBlock
            title="two_eco_wins_with_one_choice"
            descriptions={[
              "two_eco_wins_with_one_choice_description_1",
              "two_eco_wins_with_one_choice_description_2",
              "two_eco_wins_with_one_choice_description_3",
            ]}
            translationKey="used_cooking_oil_recycling"
          />
          <div className="flex flex-wrap justify-between gap-9">
            {statistics.map((stat, index) => (
              <StatisticCard
                key={index}
                icon={stat.icon}
                value={stat.value}
                unit={t(`used_cooking_oil_recycling.statistics.${stat.unitKey}`)}
                description={t(`used_cooking_oil_recycling.statistics.${stat.descriptionKey}`)}
              />
            ))}
          </div>

          <TextBlock
            title="better_for_the_environment_better_for_you"
            descriptions={[
              "better_for_the_environment_better_for_you_description_1",
              "better_for_the_environment_better_for_you_description_2",
            ]}
            translationKey="used_cooking_oil_recycling"
          />

          {/* <figure className="mt-9 h-fit w-full overflow-hidden rounded-lg">
            <img src={image2} alt="about-us-image2" className="w-full object-cover" />
          </figure> */}
        </article>
      </ContentLayout>
    </div>
  );
};

export default UsedCookingOilRecycling;
